import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';

import imgRegister from 'src/assets/images/register-button.svg';

const RegisterButton = () => (
  <Root>
    <Link to="/register">
      <img src={imgRegister} alt="Register" />
      <p>Register Now</p>
    </Link>
  </Root>
);

export default RegisterButton;

const Root = styled.div`
  display: flex;
  justify-content: center;
  margin: 70px 0;
  font-family: ${({ theme }) => theme.fontHeader};
  a {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  p {
    color: black;
    border-bottom: 1px solid ${({ theme }) => theme.colorPrimary};
    text-transform: uppercase;
    margin-top: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/RegisterButton.js